module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_lp-data__voice03-1f7be452d5c0c79ad6c262cb0a90ad5e.png";